<div class="prescription-modal">
  <!-- Header Section -->
  <div class="modal-header-section">
    <div class="header-content">
      <div class="header-eyebrow">Medical Documentation</div>
      <h2 class="header-title"><i class="bi bi-capsule me-2"></i>Create Prescription</h2>
      <p class="header-description">
        Add medications to the patient's prescription. Once generated, the prescription cannot be
        edited. Please note this can only be done once per appointment.
      </p>
    </div>
  </div>

  <!-- Form Content -->
  <div class="modal-body-section">
    <form [formGroup]="prescriptionForm">
      <!-- Medication Input Grid -->
      <div class="medication-input-grid">
        <div class="form-group">
          <label for="prescriptionName" class="form-label-modern">
            <i class="bi bi-pills me-2"></i>Medication Name
          </label>
          <input
            id="prescriptionName"
            type="text"
            formControlName="name"
            class="form-control-modern"
            placeholder="e.g., Paracetamol, Ibuprofen"
          />
        </div>

        <div class="form-group">
          <label for="prescriptionDosage" class="form-label-modern">
            <i class="bi bi-speedometer2 me-2"></i>Dosage
          </label>
          <input
            id="prescriptionDosage"
            type="text"
            formControlName="dosage"
            class="form-control-modern"
            placeholder="e.g., 500mg, 2 tablets"
          />
        </div>
      </div>

      <!-- Frequency & Method Grid -->
      <div class="medication-input-grid">
        <div class="form-group">
          <label for="prescriptionFrequency" class="form-label-modern">
            <i class="bi bi-clock-history me-2"></i>Frequency
          </label>
          <select
            id="prescriptionFrequency"
            formControlName="frequency"
            class="form-control-modern select-control"
          >
            <option value="" disabled>Select frequency</option>
            @for (freq of frequencyOptions; track freq) {
              <option [value]="freq">{{ freq }}</option>
            }
          </select>
        </div>

        <div class="form-group">
          <label for="prescriptionIngestionMethod" class="form-label-modern">
            <i class="bi bi-droplet-half me-2"></i>Ingestion Method
          </label>
          <select
            id="prescriptionIngestionMethod"
            formControlName="ingestionMethod"
            class="form-control-modern select-control"
          >
            <option value="" disabled>Select method</option>
            @for (method of ingestionMethods; track method) {
              <option [value]="method">{{ method }}</option>
            }
          </select>
        </div>
      </div>

      <!-- Add Button -->
      <div class="add-medication-section">
        <button
          type="button"
          class="btn btn-add-medication"
          (click)="addMedication()"
          [disabled]="
            !prescriptionForm.get('name')?.value ||
            !prescriptionForm.get('dosage')?.value ||
            !prescriptionForm.get('frequency')?.value ||
            !prescriptionForm.get('ingestionMethod')?.value
          "
        >
          <i class="bi bi-plus-circle me-2"></i>Add Medication
        </button>
      </div>
    </form>

    <!-- Medications Table -->
    @if (medications.length > 0) {
      <div class="medications-table-section">
        <div class="table-header">
          <h3 class="table-title"><i class="bi bi-list-ul me-2"></i>Added Medications</h3>
          <span class="medication-count"
            >{{ medications.length }} item{{ medications.length > 1 ? 's' : '' }}</span
          >
        </div>
        <div class="table-wrapper">
          <table class="medications-table">
            <thead>
              <tr>
                <th>Medication</th>
                <th>Dosage</th>
                <th>Frequency</th>
                <th>Method</th>
              </tr>
            </thead>
            <tbody>
              @for (med of medications; track med.name) {
                <tr>
                  <td class="med-name"><i class="bi bi-capsule me-2"></i>{{ med.name }}</td>
                  <td>{{ med.dosage }}</td>
                  <td>
                    <span class="frequency-badge">{{ med.frequency }}</span>
                  </td>
                  <td>{{ med.appliedArea }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>

  <!-- Actions Section -->
  <div class="modal-actions-section">
    <button
      type="button"
      class="btn btn-secondary-modern"
      (click)="cancelPrescription()"
      title="Close without generating"
    >
      <i class="bi bi-x-lg me-2"></i>Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary-modern"
      [disabled]="medications.length === 0"
      (click)="generatePrescription()"
      title="Generate and download prescription"
    >
      <i class="bi bi-download me-2"></i>Generate & Download
    </button>
  </div>
</div>
